import { FC } from 'react';
import { useMaterialReactTable, type MRT_ColumnDef } from 'material-react-table';

import { CustomTable } from 'src/presentations/components/molecules/table/Table';
import { formatMoney } from 'src/utils/utility';
import { TableChargesItem } from './types';

const useColumns = (): MRT_ColumnDef<TableChargesItem>[] => [
  {
    enableEditing: false,
    accessorKey: 'no',
    header: 'No',
  },
  {
    enableEditing: false,
    accessorKey: 'chargeName',
    header: 'Charge Name',
  },
  {
    enableEditing: false,
    accessorKey: 'quantity',
    header: 'Quantity',
  },
  {
    enableEditing: false,
    accessorKey: 'totalAmount',
    header: 'Total Amount',
    accessorFn: (row) => <>{formatMoney(row?.totalAmount || 0, row?.totalAmountCurrency || '')}</>,
  },
];

interface ITableChargesProps {
  data: TableChargesItem[];
}

export const TableCharges: FC<ITableChargesProps> = (props) => {
  const { data = [] } = props;
  const columns = useColumns();

  const table = useMaterialReactTable({
    enableSorting: false,
    enablePinning: false,
    enableRowDragging: false,
    enableColumnActions: false,
    enablePagination: false,
    enableTopToolbar: false,
    enableBottomToolbar: false,
    enableEditing: false,
    editDisplayMode: 'table',
    enableRowSelection: false,
    enableMultiRowSelection: false,
    data,
    columns,
  });

  return (
    <>
      <h3 className='mb-24 text-primary text-14 font-bold'>LIST OF ACCESSORIAL CHARGES REQUIRING AN APPROVAL</h3>
      <CustomTable table={table} />
    </>
  );
};
